'use client'
import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "Why is SEO important for my business?",
    answer: "SEO (Search Engine Optimization) increases your website's visibility on search engines like Google. It drives organic traffic, builds credibility, and improves user experience — helping your business attract more qualified leads and stay ahead of the competition."
  },
  {
    question: "How long does it take to see results from SEO?",
    answer: "SEO is a long-term strategy. While some improvements can be seen in a few weeks, significant results typically take 3 to 6 months depending on your industry, competition, and the current state of your website."
  },
  {
    question: "What SEO services do you offer?",
    answer: "We offer comprehensive SEO services including keyword research, on-page optimization, technical SEO, backlink building, content creation, local SEO, and performance tracking — all tailored to your business goals."
  },
  {
    question: "How do you measure SEO success?",
    answer: "We track key metrics such as keyword rankings, organic traffic, bounce rate, domain authority, and conversions. You'll receive detailed reports to monitor progress and understand the impact of our SEO efforts."
  },
  {
    question: "Will you make changes to my website?",
    answer: "Yes. With your approval, we implement on-page SEO changes, improve site speed, fix technical issues, and optimize content to ensure your website meets search engine guidelines and delivers a better user experience."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className='col text-center py-5 mt-5' data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div className="container" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level={3}  // ✅ This resolves the warning
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <span>{item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div
                    className="accordion__panel faq-ans"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
